import messages from './messages';

const schema = ({ intl }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.defaultFieldset),
      fields: [
        'eyebrow',
        'heading',
        'body',
        'formula',
        'service_info',
        'price_note',
        'menu_note',
        'cta_label',
        'cta_href',
        'image_side',
        'image',
      ],
    },
  ],
  properties: {
    eyebrow: {
      title: intl.formatMessage(messages.eyebrow),
      type: 'string',
      default: intl.formatMessage(messages.defaultEyebrow),
    },
    heading: {
      title: intl.formatMessage(messages.heading),
      type: 'string',
      default: intl.formatMessage(messages.defaultHeading),
    },
    body: {
      title: intl.formatMessage(messages.body),
      type: 'string',
      widget: 'textarea',
      default: intl.formatMessage(messages.defaultBody),
    },
    formula: {
      title: intl.formatMessage(messages.formula),
      type: 'string',
      default: intl.formatMessage(messages.defaultFormula),
    },
    service_info: {
      title: intl.formatMessage(messages.serviceInfo),
      type: 'string',
      default: intl.formatMessage(messages.defaultServiceInfo),
    },
    price_note: {
      title: intl.formatMessage(messages.priceNote),
      type: 'string',
      default: intl.formatMessage(messages.defaultPriceNote),
    },
    menu_note: {
      title: intl.formatMessage(messages.menuNote),
      type: 'string',
      widget: 'textarea',
    },
    cta_label: {
      title: intl.formatMessage(messages.ctaLabel),
      type: 'string',
      default: intl.formatMessage(messages.defaultCtaLabel),
    },
    cta_href: {
      title: intl.formatMessage(messages.ctaHref),
      type: 'string',
      description: intl.formatMessage(messages.ctaHrefDescription),
      default: '/carte',
    },
    image_side: {
      title: intl.formatMessage(messages.imageSide),
      type: 'string',
      choices: [
        ['right', intl.formatMessage(messages.imageSideRight)],
        ['left', intl.formatMessage(messages.imageSideLeft)],
      ],
      default: 'right',
    },
    image: {
      title: intl.formatMessage(messages.image),
      type: 'string',
      widget: 'object_browser',
      mode: 'image',
      description: intl.formatMessage(messages.imageDescription),
    },
  },
  required: [],
});

export default schema;
